import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { t } from 'src/lib/language';
import { BASE_URL } from 'src/environments/environment';

interface OwnProps {
  paymentId: number;
}

type Props = OwnProps & ButtonProps;

const ShowInvoicesForPaymentButton = (props: Props) => {
  const { disabled, paymentId } = props;
  const lang = useSelector((state: Store) => state.language.language);

  const onClick = () => {
    if (!paymentId) return;
    window.open(`${BASE_URL}/invoices/payment/${paymentId}`);
  };

  return (
    <Tooltip
      title={t(lang, 'menus.show_invoice_payments')}
      placement="top-start">
      <span>
        <ActionButton
          category={MENU_BUTTON_CATEGORY.presets}
          onClick={onClick}
          disabled={disabled}>
          <DescriptionOutlinedIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default ShowInvoicesForPaymentButton;
